<div class="d-flex flex-column referral-sectiom-wrapper">
  <div class="d-flex flex-column referral-industry-wrapper">
    <div class="referral-section-title">
      <h3>
        Tell us about you
      </h3>
      <span>
        We'll recommend the right Time and attendance solutions.
      </span>
    </div>
    <div class="d-flex flex-column">
      <mat-form-field class="industry-field">
        <mat-label>Please select your industry</mat-label>
        <mat-select [formControl]="industryControl">
          <mat-option>
            <ngx-mat-select-search
            [formControl]="industryFilterCtrl"
            [placeholderLabel]="'Search'"
            [noEntriesFoundLabel]="'Industry not found'"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let industry of filteredIndustry | async" [value]="industry">
            {{industry}}
          </mat-option>
        </mat-select>
        <mat-error>Please Select <strong>Industry</strong></mat-error>
      </mat-form-field>

      <mat-form-field *ngIf="industryControl.value && industryControl.value.includes('Other')">
        <textarea matInput rows="1" placeholder="Specify Industry" [formControl]="otherIndustry" style="resize: none;"></textarea>
        <mat-error *ngIf="otherIndustry.hasError('required')">Please Specify <strong>Industry</strong></mat-error>
        <mat-error *ngIf="otherIndustry.hasError('specialChars')"><strong>Special characters</strong> not allowed</mat-error>
        <mat-error *ngIf="otherIndustry.hasError('urlsOrScripts') && !otherIndustry.hasError('specialChars')">Enter a valid <strong>Industry</strong></mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="referral-goals-wrapper d-flex flex-column">
    <div class="referral-section-title d-flex flex-column">
      <h3>
        Where did you hear about us?
      </h3>
      <!-- <span>
        Select anything that applies to your organization.
      </span> -->
    </div>
    <div class="d-flex flex-column">
      <div class="referral-goals-selection">
        <ng-container *ngFor="let card of references; let index = index">
          <div class="goal-card d-flex justify-content-between align-items-center" (click)="selectReference(card)" [attr.is_checked]="card.is_checked ? '1' : '0'">
            <div class="d-flex justify-content-between align-items-center w-100">
              <div class="d-flex flex-column">
                <span class="card-name">{{card.name}}</span>
                <span class="card-desc">{{card.description}}</span>
              </div>
              <span class="unchecked" *ngIf="!card.is_checked"></span>
              <img *ngIf="card.is_checked" width="24" height="24" src="./assets/svg/circle-checked-icon.svg" alt="Green Checked Icon">
            </div>
          </div>
        </ng-container>
      </div>
      <span class="referrence-err-text" *ngIf="show_error">Please select <strong>atleast one Reference</strong></span>

      <mat-form-field *ngIf="isOtherSelected()" class="w-50 pe-3">
        <textarea matInput rows="1" placeholder="Please Specify" [formControl]="otherReference" style="resize: none;"></textarea>
        <mat-error *ngIf="otherReference.hasError('required')">Please Specify <strong>where did you hear about us!</strong></mat-error>
        <mat-error *ngIf="otherReference.hasError('specialChars')"><strong>Special characters</strong> not allowed</mat-error>
        <mat-error *ngIf="otherReference.hasError('urlsOrScripts') && !otherReference.hasError('specialChars')">Enter valid <strong>Details</strong></mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="d-flex justify-content-center align-items-center">
    <button #getStartedButton type="button" class="btn btn-sm continue-btn" [class.celebrate]="is_celebrating" mat-flat-button (click)="loginToDashboard()" [disabled]="is_loading">Get Started
      <mat-icon *ngIf="is_loading" class="ms-2">
          <mat-spinner diameter="25"></mat-spinner>
      </mat-icon>
    </button>
  </div>
</div>
